import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class FormService {
  constructor(private apiService: ApiService) { }

  getListOfForms(id) {
    return this.apiService.get('/formlist/' + id).map(data => data);
  }

  create(form,appid) {
    return this.apiService.post('/form/'+ appid, form).map(data => data);
  }

  delete(id,appid) {
    return this.apiService.delete('/form/' + appid + '/app/'+ id).map(data => data);
  }

  getFormById(id) {
    return this.apiService.get('/form/' + id).map(data => data);
  }

  getListOfFormRequests(appId) {
    return this.apiService.get('/formrequestlist/' + appId).map(data => data);
  }

  approve(form, appid) {
    return this.apiService.post('/formapproved/' + appid, form).map(data => data);
  }

  reject(form, appid) {    
    return this.apiService.post('/formrejected/' + appid, form).map(data => data);
  }

}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/form-management/form-management.ts